import { render, staticRenderFns } from "./ResetCompanyUserPasswordDialog.vue?vue&type=template&id=7f513ee5&"
import script from "./ResetCompanyUserPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ResetCompanyUserPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports